module.exports = __webpack_public_path__ + "img/calendar.c657de69.svg";